// 受検日To
import { atom } from "recoil";
import { AtomKeys } from "../recoilKeys";

// 受検日ToのAtom（データストア）
export const dateToState = atom<Date | null>({
    key: AtomKeys.DATE_TO_STATE,
    default: null,
});
